// Product.js
// Component for Product view

// Imports
import React from 'react';
import { Colors } from "@blueprintjs/core";
import Quantity from './Quantity';
import UnitSelector from './UnitSelector';
import CustomPrice from './CustomPrice';
import PropTypes from 'prop-types';

// Component Class
// Shows Product entry
class Product extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    var order = this.getOrder();
    this.state = {
      unitId: order.unitId,
    };
  }

  // Returns the associated order, with quantity and unitId
  getOrder = () => {
    var order;
    if (this.props.order)
      order = this.props.order[this.props.id];

    if (!order)
      order = { quantity: "", unitId: 0 };
    return order;
  }

  // Sets the product quantity
  setQuantity = (quantity) => {
    var pId = this.props.product.id;
    var order = this.props.order ? this.props.order[pId] : null;
    var unitId = order ? order.unitId : 0;
    var customPrice = order ? order.customPrice : undefined;
    this.props.setQuantity(pId, unitId, quantity, customPrice);
  }

  // Sets the target unit
  setUnit = (unitId) => {
    this.setState({ unitId: unitId });
    var pId = this.props.product.id;
    var order = this.props.order[pId];
    var quantity = order ? order.quantity : 0;
    var customPrice = order ? order.customPrice : undefined;
    this.props.setQuantity(pId, unitId, quantity, customPrice);
  }

  // Sets a custom price for the products
  setPrice = (price) => {
    var pId = this.props.product.id;
    var order = this.props.order[pId];
    var quantity = order ? order.quantity : 0;
    var unitId = order ? order.unitId : 0;
    this.props.setQuantity(pId, unitId, quantity, price);
  }

  // Renders Component
  render() {
    var price = this.props.product.price[this.state.unitId].price;
    var bgColor = this.props.order && this.props.order[this.props.product.id] ? Colors.GREEN5 : undefined;
    return (
      <tr style={{verticalAlignment: 'middle'}}>
        <td style={{backgroundColor: bgColor }}>{this.props.product.name}</td>
        <td> 
          <center>
            <Quantity
              setQuantity={this.setQuantity}
              unitId={this.state.unitId}
              id={this.props.id}
              order={this.props.order}
            />
          </center>
        </td>
        <td>
          <center>
            <UnitSelector
              setUnit={this.setUnit}
              product={this.props.product}
              order={this.props.order}
            />
          </center>
        </td>
        <td>
          <center>
            R$ {price.toFixed(2)}
          </center>
        </td>
        <td>
          <center>
            <CustomPrice
              setPrice={this.setPrice}
              product={this.props.product}
              order={this.props.order}
              orderData={this.props.orderData}
            />
          </center>
        </td>
        <td>
          <center>
            R$ {this.props.orderData.getProductTotal(this.props.id).toFixed(2)}
          </center>
        </td>
      </tr>
    );
  }
}

// Required Properties
Product.propTypes = {
  id: PropTypes.number.isRequired,
  product: PropTypes.object.isRequired,
  order: PropTypes.object,
  orderData: PropTypes.object.isRequired,
  setQuantity: PropTypes.func.isRequired,
}

// Exports
export default Product;


// WEBPACK FOOTER //
// ./src/components/OrderView/Product.js